import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";

import { patchCourseImportTranslationsCsv } from "../../../../actions/course-author/common";
import { IState } from "../../../../App/reducer";
import { ImportTranslationsComponent } from "./ImportTranslations.component";
import { IImportTranslationDispatchProps, IImportTranslationStateProps } from "./ImportTranslations.types";

const mapStateToProps = (state: IState): IImportTranslationStateProps => ({
  uploadError: state.App.CourseAuthor._.patchCourseImportTranslationsCsvFailure,
});

const mapDispatchToProps = (dispatch: Dispatch): IImportTranslationDispatchProps =>
  bindActionCreators({ uploadCsv: patchCourseImportTranslationsCsv }, dispatch);

export const ImportTranslations = connect(mapStateToProps, mapDispatchToProps)(ImportTranslationsComponent);
